import FETCH from "../utils/fetch";
import ROUTES from "../config/routes";
const addPersonalInstructions = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.PERSONAL_INSTRUCTIONS,
    body,
  });
  return res;
};
const updatePersonalInstructions = async (id, body) => {
  let res = await FETCH.put({
    url: ROUTES.PERSONAL_INSTRUCTIONS,
    id,
    body,
  });
  return res;
};

const fetchPersonalInstructions = async (id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  let res = await FETCH.get({
    // url: ROUTES.PERSONAL_INSTRUCTIONS,
    url:
      userRole === "protrustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.PERSONAL_INSTRUCTIONS}?id=${id}`
        : ROUTES.PERSONAL_INSTRUCTIONS,
  });
  return res;
};
const fetchContactList = async (id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  let res = await FETCH.get({
    // url: ROUTES.CONTACT_LIST,
    // url: `${ROUTES.CONTACT_LIST}?id=${id}`,
    url:
      userRole === "protrustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.CONTACT_LIST}?id=${id}`
        : ROUTES.CONTACT_LIST,
  });
  return res;
};
const fetchTrusteeList = async () => {
  let res = await FETCH.get({
    // url: ROUTES.CONTACT_LIST,
    // url: `${ROUTES.CONTACT_LIST}?id=${id}`,
    url: ROUTES.CONTACT_LIST,
  });
  return res;
};
const addContactList = async (body, id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  let res = await FETCH.post({
    url:
      userRole === "protrustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.CONTACT_LIST}?clientId=${id}`
        : ROUTES.CONTACT_LIST,
    body,
  });
  return res;
};
const addPasswords = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.PASSWORDS,
    body,
  });
  return res;
};
const updatePasswords = async (id, body) => {
  let res = await FETCH.put({
    url: ROUTES.PASSWORDS,
    id,
    body,
  });
  return res;
};
const deletePersonalInstruction = async (id) => {
  let res = await FETCH.deletee({
    url: ROUTES.PERSONAL_INSTRUCTIONS,
    id,
  });
  return res;
};
const deleteContact = async (id) => {
  let res = await FETCH.deletee({
    url: ROUTES.CONTACT_LIST,
    id,
  });
  return res;
};
const fetchPasswords = async (value, id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  let res = await FETCH.get({
    // url: ROUTES.PASSWORDS,
    // url: `${ROUTES.PASSWORDS}?otp=${value}`,
    url:
      userRole === "protrustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.PASSWORDS}?otp=${value}&id=${id}`
        : `${ROUTES.PASSWORDS}?otp=${value}`,
  });
  return res;
};
const deletePassword = async (id) => {
  let res = await FETCH.deletee({
    url: ROUTES.PASSWORDS,
    id,
  });
  return res;
};
const fetchPrepaidBurial = async (id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  let res = await FETCH.get({
    // url: ROUTES.PREPAID_BURIAL,
    url:
      userRole === "protrustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.PREPAID_BURIAL}?id=${id}`
        : ROUTES.PREPAID_BURIAL,
  });
  return res;
};
const deletePrepaidBurial = async (id) => {
  let res = await FETCH.deletee({
    url: ROUTES.PREPAID_BURIAL,
    id,
  });
  return res;
};
const addPrepaidBurial = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.PREPAID_BURIAL,
    body,
  });
  return res;
};

const getSecureLink = async (id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  let res = await FETCH.get({
    url:
      userRole === "protrustee" || userRole === "trustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.GET_SECURE_LINK}?id=${id}`
        : `${ROUTES.GET_SECURE_LINK}`,
  });
  return res;
};
const createSecureLink = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.SECURE_LINK,
    body,
  });
  return res;
};
const deleteSecureLink = async (id) => {
  let res = await FETCH.deletee({
    url: `${ROUTES.DELETE_SECURELINK}?id=${id}`,
  });
  return res;
};
const getIprefer = async (id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  let res = await FETCH.get({
    url:
      userRole === "protrustee" || userRole === "trustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.I_PREFER}?id=${id}`
        : `${ROUTES.I_PREFER}`,
  });
  return res;
};
const getPlaceofService = async (id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  let res = await FETCH.get({
    url:
      userRole === "protrustee" || userRole === "trustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.PLACE_SERVICES}?id=${id}`
        : `${ROUTES.PLACE_SERVICES}`,
  });
  return res;
};
const getPersonalAccessories = async (id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  let res = await FETCH.get({
    url:
      userRole === "protrustee" || userRole === "trustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.PERSONAL_ACCESSORIES}?id=${id}`
        : `${ROUTES.PERSONAL_ACCESSORIES}`,
  });
  return res;
};

const addIPrefer = async (body, id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  let res = await FETCH.post({
    url:
      userRole === "protrustee" || userRole === "trustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.I_PREFER}?clientId=${id}`
        : `${ROUTES.I_PREFER}`,
    body,
  });
  return res;
};
const addPlaceofService = async (body, id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  let res = await FETCH.post({
    url:
      userRole === "protrustee" || userRole === "trustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.PLACE_SERVICES}?clientId=${id}`
        : `${ROUTES.PLACE_SERVICES}`,
    body,
  });
  return res;
};
const addPersonalAccessories = async (body, id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  let res = await FETCH.post({
    url:
      userRole === "protrustee" || userRole === "trustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.PERSONAL_ACCESSORIES}?clientId=${id}`
        : `${ROUTES.PERSONAL_ACCESSORIES}`,
    body,
  });
  return res;
};

const updateIPrefer = async (id, body, ID) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  let res = await FETCH.put2({
    url:
      userRole === "protrustee" || userRole === "trustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.I_PREFER}?clientId=${ID}&id=${id}`
        : `${ROUTES.I_PREFER}?id=${id}`,
    id,
    body,
  });
  return res;
};
const updatePlaceofService = async (id, body, ID) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  let res = await FETCH.put2({
    url:
      userRole === "protrustee" || userRole === "trustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.PLACE_SERVICES}?clientId=${ID}&id=${id}`
        : `${ROUTES.PLACE_SERVICES}?id=${id}`,
    id,
    body,
  });
  return res;
};

const updatePersonalAccessories = async (id, body, ID) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  let res = await FETCH.put2({
    url:
      userRole === "protrustee" || userRole === "trustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.PERSONAL_ACCESSORIES}?clientId=${ID}&id=${id}`
        : `${ROUTES.PERSONAL_ACCESSORIES}?id=${id}`,
    id,
    body,
  });
  return res;
};

const deleteIPrefer = async (id) => {
  console.log("deltedis", id);
  let res = await FETCH.put2({
    url: `${ROUTES.I_PREFER}/delete?id=${id}`,
    // id,
  });
  return res;
};
const deletePlaceofService = async (id) => {
  console.log("deltedis", id);
  let res = await FETCH.put2({
    url: `${ROUTES.PLACE_SERVICES}/delete?id=${id}`,
    // id,
  });
  return res;
};
const deletePersonalAccessories = async (id) => {
  console.log("deltedis", id);
  let res = await FETCH.put2({
    url: `${ROUTES.PERSONAL_ACCESSORIES}/delete?id=${id}`,
    // id,
  });
  return res;
};

const fetchBills = async (id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  let res = await FETCH.get({
    // url: ROUTES.BILLS_TO_PAY,
    url:
      userRole === "protrustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.BILLS_TO_PAY}?id=${id}`
        : ROUTES.BILLS_TO_PAY,
  });
  return res;
};
const deleteBills = async (id) => {
  let res = await FETCH.deletee({
    url: ROUTES.BILLS_TO_PAY,
    id,
  });
  return res;
};
const addBills = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.BILLS_TO_PAY,
    body,
  });
  return res;
};
const fetchLitigation = async (id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  let res = await FETCH.get({
    // url: ROUTES.LITIGATION,
    url:
      userRole === "protrustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.LITIGATION}?id=${id}`
        : ROUTES.LITIGATION,
  });
  return res;
};
const deleteLitigation = async (id) => {
  let res = await FETCH.deletee({
    url: ROUTES.LITIGATION,
    id,
  });
  return res;
};
const addLitigation = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.LITIGATION,
    body,
  });
  return res;
};
const addAccountAsset = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.ACCOUNT_ASSET,
    body,
  });
  return res;
};
const deleteAccountAsset = async (id) => {
  let res = await FETCH.deletee({
    url: ROUTES.ACCOUNT_ASSET,
    id,
  });
  return res;
};
const fetchAccountAsset = async () => {
  let res = await FETCH.get({
    url: ROUTES.ACCOUNT_ASSET,
  });
  return res;
};
const fetchAccountAssetLiabilities = async () => {
  let res = await FETCH.post({
    url: ROUTES.ACCOUNT_ASSET_Liabilities,
  });
  return res;
};
const addPersonalItemLocation = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.PERSONAL_ITEM_LOCATION,
    body,
  });
  return res;
};
const deletePersonalItemLocation = async (id) => {
  let res = await FETCH.deletee({
    url: ROUTES.PERSONAL_ITEM_LOCATION,
    id,
  });
  return res;
};
const fetchPersonalItemLocation = async (id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  let res = await FETCH.get({
    // url: ROUTES.PERSONAL_ITEM_LOCATION,
    url:
      userRole === "protrustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.PERSONAL_ITEM_LOCATION}?id=${id}`
        : ROUTES.PERSONAL_ITEM_LOCATION,
  });
  return res;
};
const addPolicies = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.CLIENTS_POLICIES,
    body,
  });
  return res;
};
const deletePolicy = async (id) => {
  let res = await FETCH.deletee({
    url: ROUTES.CLIENTS_POLICIES,
    id,
  });
  return res;
};
const fetchPolicy = async (value, id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  let res = await FETCH.get({
    // url: ROUTES.CLIENTS_POLICIES,
    // url: `${ROUTES.CLIENTS_POLICIES}?otp=${value}`,
    url:
      userRole === "protrustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.CLIENTS_POLICIES}?otp=${value}&id=${id}`
        : `${ROUTES.CLIENTS_POLICIES}?otp=${value}`,
  });
  return res;
};
const addDocuments = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.CLIENTS_DOCUMENTS,
    body,
  });
  return res;
};
const deleteDocument = async (id) => {
  let res = await FETCH.deletee({
    url: ROUTES.CLIENTS_DOCUMENTS,
    id,
  });
  return res;
};
const fetchDocuments = async (value, id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  console.log("id", id);
  let res = await FETCH.get({
    // url: `${ROUTES.CLIENTS_DOCUMENTS}?otp=${value}`,
    url:
      userRole === "protrustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.CLIENTS_DOCUMENTS}?otp=${value}&id=${id}`
        : `${ROUTES.CLIENTS_DOCUMENTS}?otp=${value}`,

    // url: ROUTES.CLIENTS_DOCUMENTS
  });
  return res;
};
const upsertChecklist = async (body) => {
  const res = await FETCH.post({
    url: ROUTES.CHECKLIST,
    body,
  });
  return res;
};
const fetchChecklist = async (id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  let res = await FETCH.get({
    // url: ROUTES.CHECKLIST,
    url:
      userRole === "protrustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.CHECKLIST}?id=${id}`
        : ROUTES.CHECKLIST,
  });
  return res;
};
const updateContact = async (id, body) => {
  let res = await FETCH.put({
    url: ROUTES.CONTACT_LIST,
    id,
    body,
  });
  return res;
};
const updatePrepaidBurial = async (id, body) => {
  let res = await FETCH.put({
    url: ROUTES.PREPAID_BURIAL,
    id,
    body,
  });
  return res;
};
const updateBills = async (id, body) => {
  let res = await FETCH.put({
    url: ROUTES.BILLS_TO_PAY,
    id,
    body,
  });
  return res;
};
const getSpouseDetails = async () => {
  let res = await FETCH.get({
    url: ROUTES.SPOUSEINFO,
  });
  return res;
};
const getDependentDetails = async () => {
  let res = await FETCH.get({
    url: ROUTES.DEPENDENT_DETAILS,
  });
  return res;
};
const getTrustInfo = async () => {
  let res = await FETCH.get({
    url: ROUTES.TRUST_INFO,
  });
  return res;
};
const getCorporateInfo = async () => {
  let res = await FETCH.get({
    url: ROUTES.CORPORATE_INFO,
  });
  return res;
};
const getCharityInfo = async () => {
  let res = await FETCH.get({
    url: ROUTES.CHARITY_INFO,
  });
  return res;
};
const getOtherImpacts = async () => {
  let res = await FETCH.get({
    url: ROUTES.OTHER_IMPACTS,
  });
  return res;
};
const addSpouseInfo = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.CREATE_SPOUSE,
    body,
  });
  return res;
};
const addDependentInfo = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.CREATE_DEPENDENT,
    body,
  });
  return res;
};
const addTrustInfo = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.CREATE_TRUST_INFO,
    body,
  });
  return res;
};
const addCorporateInfo = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.CREATE_CORPORATE_INFO,
    body,
  });
  return res;
};
const addCharityInfo = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.CREATE_CHARITY_INFO,
    body,
  });
  return res;
};
const addOtherImpacts = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.CREATE_OTHER_IMPACTS,
    body,
  });
  return res;
};
const updateSpouseInfo = async (id, body) => {
  let res = await FETCH.put({
    url: ROUTES.UPDATE_SPOUSE_INFO,
    id,
    body,
  });
  return res;
};
const updateDependentInfo = async (id, body) => {
  let res = await FETCH.put({
    url: ROUTES.UPDATE_DEPENDENT_INFO,
    id,
    body,
  });
  return res;
};
const updateTrustInfo = async (id, body) => {
  let res = await FETCH.put({
    url: ROUTES.UPDATE_TRUST_INFO,
    id,
    body,
  });
  return res;
};
const updateCorporateInfo = async (id, body) => {
  let res = await FETCH.put({
    url: ROUTES.UPDATE_CORPORATE_INFO,
    id,
    body,
  });
  return res;
};
const updateCharityInfo = async (id, body) => {
  let res = await FETCH.put({
    url: ROUTES.UPDATE_CHARITY_INFO,
    id,
    body,
  });
  return res;
};
const updateOtherImpacts = async (id, body) => {
  let res = await FETCH.put({
    url: ROUTES.UPDATE_OTHER_IMPACTS,
    id,
    body,
  });
  return res;
};
const deleteSpouseInfo = async (id) => {
  let res = await FETCH.deletee({
    url: `${ROUTES.DELETE_SPOUSE_INFO}?spouseId=${id}`,
  });
  return res;
};
const deleteDependentInfo = async (id) => {
  let res = await FETCH.deletee({
    url: `${ROUTES.DELETE_DEPENDENT_INFO}?dependentId=${id}`,
  });
  return res;
};
const searchContactList = async (body) => {
  console.log("search value in body", body);
  let res = await FETCH.get({
    url: `${ROUTES.CONTACT_LIST}?searchParam=${body}`,
  });
  return res;
};
const deleteTrustInfo = async (id) => {
  let res = await FETCH.deletee({
    url: `${ROUTES.DELETE_TRUST_INFO}?trustId=${id}`,
  });
  return res;
};
const deleteCorporateInfo = async (id) => {
  let res = await FETCH.deletee({
    url: `${ROUTES.DELETE_CORPORATE_INFO}?corporateId=${id}`,
  });
  return res;
};
const deleteCharityInfo = async (id) => {
  let res = await FETCH.deletee({
    url: `${ROUTES.DELETE_CHARITY_INFO}?charityId=${id}`,
  });
  return res;
};
const deleteOtherImpacts = async (id) => {
  let res = await FETCH.deletee({
    url: `${ROUTES.DELETE_OTHER_IMPACTS}?otherImpactId=${id}`,
  });
  return res;
};
const updateAccountAsset = async (id, body) => {
  let res = await FETCH.put({
    url: ROUTES.ACCOUNT_ASSET,
    id,
    body,
  });
  return res;
};
const revertDeath = async (id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  let res = await FETCH.put2({
    // url: ROUTES.REVERT_DEATH,
    url:
      userRole == "trustee" || userRole === "protrustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.REVERT_DEATH}?id=${id}`
        : `${ROUTES.REVERT_DEATH}`,
  });
  return res;
};
const updatePersonalItemLocation = async (id, body) => {
  let res = await FETCH.put({
    url: ROUTES.PERSONAL_ITEM_LOCATION,
    id,
    body,
  });
  return res;
};
const updateLitigation = async (id, body) => {
  let res = await FETCH.put({
    url: ROUTES.LITIGATION,
    id,
    body,
  });
  return res;
};
const updateDocument = async (id, body) => {
  let res = await FETCH.put({
    url: ROUTES.CLIENTS_DOCUMENTS,
    id,
    body,
  });
  return res;
};
const getDeathStatus = async (id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  console.log("id", id);
  console.log("userRole", userRole);
  let res = await FETCH.get({
    // url: ROUTES.DEATH_STATUS,
    url:
      userRole === "protrustee" || userRole === "trustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.DEATH_STATUS}?id=${id}`
        : `${ROUTES.DEATH_STATUS}`,
  });
  return res;
};
const updatePolicy = async (id, body) => {
  let res = await FETCH.put({
    url: ROUTES.CLIENTS_POLICIES,
    id,
    body,
  });
  return res;
};
const updateEmail = async (id, body) => {
  let res = await FETCH.put({
    url: ROUTES.EMAIL_TO_SEND,
    id,
    body,
  });
  return res;
};
const addEmail = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.EMAIL_TO_SEND,
    body,
  });
  return res;
};
const deleteEmail = async (id) => {
  let res = await FETCH.deletee({
    url: ROUTES.EMAIL_TO_SEND,
    id,
  });
  return res;
};
const fetchEmail = async (id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  let res = await FETCH.get({
    // url: ROUTES.EMAIL_TO_SEND
    url:
      userRole === "protrustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.EMAIL_TO_SEND}?id=${id}`
        : ROUTES.EMAIL_TO_SEND,
  });
  return res;
};
const updateText = async (id, body) => {
  let res = await FETCH.put({
    url: ROUTES.TEXTS_TO_SEND,
    id,
    body,
  });
  return res;
};
const addText = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.TEXTS_TO_SEND,
    body,
  });
  return res;
};
const deleteText = async (id) => {
  let res = await FETCH.deletee({
    url: ROUTES.TEXTS_TO_SEND,
    id,
  });
  return res;
};
const fetchText = async (id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  let res = await FETCH.get({
    // url: ROUTES.TEXTS_TO_SEND
    url:
      userRole === "protrustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.TEXTS_TO_SEND}?id=${id}`
        : ROUTES.TEXTS_TO_SEND,
  });
  return res;
};
const fetchTemplates = async (id, value) => {
  let res = await FETCH.get({
    url: `${ROUTES.EMAIL_TO_SEND}?templateName=${id}`,
  });
  return res;
};

const updateAudioVideo = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.AUDIO_VIDEO,
    body,
  });
  return res;
};
const uploadPasswordSheet = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.UPLOAD_DOCUMENT}?fileType=${"password"}`,
    body,
    isFormData: true,
  });
  return res;
};
const uploadDocumnet = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.UPLOAD_DOCUMENT}?fileType=${"document"}`,
    body,
    isFormData: true,
  });
  return res;
};
const uploadPolicy = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.UPLOAD_DOCUMENT}?fileType=${"policy"}`,
    body,
    isFormData: true,
  });
  return res;
};
const exportPasswordSheet = async (value) => {
  let res = await FETCH.get({
    url: `${ROUTES.EXPORT_DOCUMENT}?fileType=${value}&exportData=true`,
  });
  return res;
};
const exportDocumentSheet = async (value) => {
  let res = await FETCH.get({
    url: `${ROUTES.EXPORT_DOCUMENT}?fileType=${value}&exportData=true`,
  });
  return res;
};
const exportPolicySheet = async (value, id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  let res = await FETCH.get({
    url:
      userRole === "protrustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.EXPORT_DOCUMENT}?fileType=${value}&exportData=true&clientId=${id}`
        : `${ROUTES.EXPORT_DOCUMENT}?fileType=${value}&exportData=true`,
  });
  return res;
};
const exportContactsSheet = async (value) => {
  let res = await FETCH.get({
    url: `${ROUTES.EXPORT_DOCUMENT}?fileType=${value}&exportData=true`,
  });
  return res;
};
const getPasswordTemplates = async (value) => {
  let res = await FETCH.get({
    url: `${ROUTES.DOWNLOAD_TEMPLATE}?fileType=${value}`,
  });
  return res;
};
const getDocumentTemplates = async (value) => {
  let res = await FETCH.get({
    url: `${ROUTES.DOWNLOAD_TEMPLATE}?fileType=${value}`,
  });
  return res;
};
const getPolicyTemplates = async (value) => {
  let res = await FETCH.get({
    url: `${ROUTES.DOWNLOAD_TEMPLATE}?fileType=${value}`,
  });
  return res;
};
const configOtp = async (id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  let res = await FETCH.get({
    // url: ROUTES.OTP_CONFIG
    url:
      userRole === "protrustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.OTP_CONFIG}?id=${id}`
        : ROUTES.OTP_CONFIG,
  });
  return res;
};
const confirmDeath = async (id) => {
  let res = await FETCH.post({
    url: ROUTES.CONFIRM_DEATH,
    body: {
      id: +id,
    },
  });
  return res;
};
const postTemplate = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.POST_TEMPLATE,
    body,
  });
  return res;
};
const getTemplate = async (value) => {
  let res = await FETCH.get({
    url: ROUTES.POST_TEMPLATE,
  });
  return res;
};
const setRevertTime = async (value) => {
  console.log("value in api", value);
  let res = await FETCH.put2({
    url: `${ROUTES.TIMER}`,
    body: { deathStatusRevertTime: value },
  });
  return res;
};
const fetchEmailTemplates = async (id, value) => {
  let res = await FETCH.get({
    url: `${ROUTES.POST_TEMPLATE}?emailTemplateId=${id}`,
  });
  return res;
};
const verifyOtp = async (body, config) => {
  console.log("config data", config);
  let res = await FETCH.post({
    url: `${ROUTES.OTP_VERIFY}`,
    body,
    config,
  });
  return res;
};
const fetchAudioVideo = async (id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  let res = await FETCH.get({
    // url: ROUTES.AUDIO_VIDEO,
    url:
      userRole === "protrustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.AUDIO_VIDEO}?id=${id}`
        : ROUTES.AUDIO_VIDEO,
  });
  return res;
};
const fetchClientList = async (token) => {
  let res = await FETCH.get({
    url: ROUTES.CLIENT_LIST,
  });
  return res;
};
const addAdvanceHealth = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.ADVANCE_HEALTH,
    body,
  });
  return res;
};
const updateAdvanceHealth = async (body) => {
  let res = await FETCH.put2({
    url: ROUTES.ADVANCE_HEALTH,
    body,
  });
  return res;
};
const getAdvanceHealth = async (id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  let res = await FETCH.get({
    url:
      userRole === "protrustee" || userRole === "trustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.ADVANCE_HEALTH}?clientId=${id}`
        : ROUTES.ADVANCE_HEALTH,
  });
  return res;
};
const SendEmails = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.SEND_EMAIL}`,
    body,
  });
  return res;
};
const PostDeathCertificate = async (body) => {
  // const userRole = localStorage.getItem("role") != 'undefined' && JSON.parse(localStorage.getItem("role"))
  let res = await FETCH.post({
    // url: userRole === "protrustee" || userRole === "trustee" ? `${ROUTES.DEATH_CERTIFICATE}?id=${id}` : ROUTES.DEATH_CERTIFICATE,
    url: `${ROUTES.DEATH_CERTIFICATE}`,
    body,
  });
  return res;
};
const getDeathCertificate = async (id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  let res = await FETCH.get({
    url:
      userRole === "protrustee" || userRole === "trustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.DEATH_CERTIFICATE}?id=${id}`
        : ROUTES.DEATH_CERTIFICATE,
  });
  return res;
};
const postTextTemplate = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.TEXT_TEMPLATE,
    body,
  });
  return res;
};
const getTextTemplate = async (value) => {
  let res = await FETCH.get({
    url: ROUTES.TEXT_TEMPLATE,
  });
  return res;
};
const fetchTextTemplates = async (id, value) => {
  let res = await FETCH.get({
    url: `${ROUTES.TEXT_TEMPLATE}?textTemplateId=${id}`,
  });
  return res;
};
const getSecondPasswordStatus = async (id) => {
  let res = await FETCH.get({
    url: `${ROUTES.SECOND_PASSWORD}?id=${id}`,
  });
  return res;
};
const postFuneralInfo = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.CLIENT_FUNERAL,
    body,
  });
  return res;
};
const getFuneralInfo = async (id) => {
  let res = await FETCH.get({
    url: `${ROUTES.CLIENT_FUNERAL}?id=${id}`,
  });
  return res;
};
const getEmailHistory = async (email) => {
  let res = await FETCH.get({
    url: `${ROUTES.EMAIL_LOGS}?msgId=${email}`,
  });
  return res;
};
const getEmailCounts = async (id) => {
  let res = await FETCH.get({
    url: `${ROUTES.EMAIL_LOGS_COUNT}?id=${id}`,
  });
  return res;
};
const acceptInvitation = async (code) => {
  let res = await FETCH.get({
    url: `${ROUTES.ACCEPT_INVITATION}?invitationCode=${code}`,
  });
  return res;
};
const getProfileData = async (id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  let res = await FETCH.get({
    url: ROUTES.PROFILE_CHANGE,
  });
  return res;
};

const updateProfileData = async (body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.PROFILE_CHANGE}`,
    body,
  });
  return res;
};

const getRoles = async () => {
  let res = await FETCH.get({
    url: ROUTES.GET_ROLELIST,
  });
  return res;
};
const addRoles = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.CREATE_ROLE,
    body,
  });
  return res;
};
const updateRole = async (id, body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.UPDATE_ROLE}?roleId=${id}`,
    body,
  });
  return res;
};
const deleteRole = async (id) => {
  console.log("deltedis", id);
  let res = await FETCH.deletee({
    url: `${ROUTES.DELETE_ROLE}?roleId=${id}`,
  });
  return res;
};
const getPermissions = async () => {
  let res = await FETCH.get({
    url: ROUTES.GET_PERMISSIONS,
  });
  return res;
};
const addPermission = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.CREATE_PERMISSION,
    body,
  });
  return res;
};
const updatePermission = async (id, body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.UPDATE_PERMISSION}?permissionId=${id}`,
    body,
  });
  return res;
};
const deletePermission = async (id) => {
  console.log("deltedis", id);
  let res = await FETCH.deletee({
    url: `${ROUTES.DELETE_PERMISSION}?permissionId=${id}`,
  });
  return res;
};

const getUsersList = async () => {
  let res = await FETCH.get({
    url: `${ROUTES.GET_USERLIST}?pageNum=1&limit=1000`,
  });
  return res;
};
const updateUserList = async (id, body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.UPDATE_USERROLE}?userId=${id}`,
    body,
  });
  return res;
};

const createPlaidLinkToken = async (id, body) => {
  let res = await FETCH.post({
    url: id
      ? `${ROUTES.CREATE_PLAIDLINKTOKEN}?itemId=${id}`
      : `${ROUTES.CREATE_PLAIDLINKTOKEN}`,
    body,
    // url: ROUTES.CREATE_PLAIDLINKTOKEN,
  });
  return res;
};
const setPlaidPublicToken = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.SET_PLAID_PUBLICTOKEN,
    body,
  });
  return res;
};
const getBankDetails = async () => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url: userRole === "Financial Advisor Client" 
     ? `${ROUTES.GET_BANK_DETAILS}?clientId=${ID}`
     : `${ROUTES.GET_BANK_DETAILS}`,
  });
  return res;
};
const getBankAccountDetails = async (id) => {
  let res = await FETCH.get({
    url: `${ROUTES.GET_BANK_ACCOUNT}`,
  });
  return res;
};
const stripePayment = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.STRIPE_PAYMENT,
    body,
  });
  return res;
};
const subscriptionDetails = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.SUBSCRIPTION_DETAILS,
    body,
  });
  return res;
};
const getSubscriptionList = async (id) => {
  let res = await FETCH.get({
    url: `${ROUTES.SUBSCRIPTION_LIST}`,
  });
  return res;
};
const getStripeProductList = async (id) => {
  let res = await FETCH.get({
    url: `${ROUTES.STRIPE_PRODUCTS}`,
  });
  return res;
};
const getStripeProductsList = async (id) => {
  let res = await FETCH.get({
    url: `${ROUTES.STRIPE_PRODUCTS_LIST}`,
  });
  return res;
};
const cancelSubscription = async () => {
  let res = await FETCH.post({
    url: ROUTES.CANCEL_SUBSCRIPTION,
  });
  return res;
};
const promoCodeDetails = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.APPLY_PROMO,
    body,
  });
  return res;
};
const getCustomerCardsList = async () => {
  let res = await FETCH.get({
    url: `${ROUTES.CUSTOMER_CARDS}`,
  });
  return res;
};
const deleteCustomerCard = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.DELETE_CARD,
    body,
  });
  return res;
};
const addToPlan = async (body) => {
  let res = await FETCH.post({
    // url:`${ROUTES.ADD_TO_PLAN}?id=${id}&clientModuleId=${clientModuleId}`,
    url: `${ROUTES.ADD_TO_PLAN}`,
    body,
  });
  return res;
};
const syncAllPlaidRecords = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.SYNC_ALL_PLAID,
    body,
  });
  return res;
};
const syncSinglePlaidRecord = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.SYNC_SINGLE_PLAID,
    body,
  });
  return res;
};
const sendFeedback = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.SEND_FEEDBACK,
    body,
  });
  return res;
};
const DeletePlaidAccount = async (id, body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.DELETEPLAID_ACCOUNT}?rowId=${id}`,
    body,
  });
  return res;
};
const GetCollectablesCount = async (body) => {
  let res = await FETCH.get({
    url: ROUTES.GET_COLLECTABLES_COUNT,
  });
  return res;
};

const getCollectableListing = async (moduleName, body) => {
  let res = await FETCH.post({
    url: `${ROUTES.COLLECTABLE_LISTING}?module=${moduleName}&page=1&limit=50`,
    body,
  });
  return res;
};
const addCustomerCard = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.ADD_CUSTOMER_CARD}`,
    body,
  });
  return res;
};
const makeDefaultCard = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.MAKE_DEFAULT_CARD}`,
    body,
  });
  return res;
};

const getInvoices = async (body) => {
  let res = await FETCH.get({
    url: ROUTES.GET_INOVICES,
  });
  return res;
};
const downloadInvoice = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.DOWNLOAD_INVOICE,
    body,
  });
  return res;
};
const downloadAllInvoices = async () => {
  let res = await FETCH.get({
    url: ROUTES.DOWNLOAD_ALL_INVOICES,
  });
  return res;
};

const getGoogleIntialize = async () => {
  let res = await FETCH.get({
    url: ROUTES.GET_GOOGLE_TOKEN,
  });
  return res;
};
const DeleteAllAccount = async (id, body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.DELETEALL_ACCOUNTS}?bankName=${id}`,
    // bankIds:body,
    body: { bankIds: body },
  });
  return res;
};

const getClientContacts = async () => {
  let res = await FETCH.get({
    url: `${ROUTES.GET_ALL_CONTACTS}`,
  });
  return res;
};
const getOutlookContacts = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.GET_OUTLOOK_CONTACTS,
    body,
  });
  return res;
};
const getGoogleContacts = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.GET_GOOGLE_CONTACTS,
    body,
  });
  return res;
};
const getAppleContacts = async () => {
  let res = await FETCH.get({
    url: `${ROUTES.GET_APPLE_CONTACTS}`,
  });
  return res;
};
const createGroup = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.CREATE_GROUP,
    body: { groupName: body },
  });
  return res;
};
const getGroups = async (id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  let res = await FETCH.get({
    // url:ROUTES.CREATE_GROUP,
    url:
      userRole === "protrustee" || userRole === "trustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.CREATE_GROUP}?clientId=${id}`
        : ROUTES.CREATE_GROUP,
  });
  return res;
};
const deleteGroup = async (id) => {
  let res = await FETCH.put2({
    url: `${ROUTES.DELETE_GROUP}?groupId=${id}`,
  });
  return res;
};
const updateGroup = async (id, body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.UPDATE_GROUP}?groupId=${id}`,
    body: { groupName: body },
  });
  return res;
};
const getGroupContacts = async (id) => {
  let res = await FETCH.get({
    url: `${ROUTES.GROUP_CONTACTS}?groupId=${id}`,
  });
  return res;
};
const createGroupContacts = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.GROUP_CONTACTS}`,
    body: body,
  });
  return res;
};
const deleteCloudContact = async (id) => {
  let res = await FETCH.put2({
    url: `${ROUTES.DELETE_CLOUD_CONTACT}?contactId=${id}`,
  });
  return res;
};
const updateCloudContact = async (id, body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.UPDATE_CLOUD_CONTACTS}?contactId=${id}`,
    body,
  });
  return res;
};
const getContactGroup = async (id) => {
  let res = await FETCH.post({
    url: `${ROUTES.CONTACT_GROUPS}?contactId=${id}`,
  });
  return res;
};
const addCloudContactGroup = async (body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.ADD_CONTACT_GROUP}`,
    body,
  });
  return res;
};
const exportCloudContacts = async (value) => {
  let res = await FETCH.get({
    url: `${ROUTES.EXPORT_CLOUD_CONTACTS}`,
  });
  return res;
};
const importContactFile = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.IMPORT_CONTACTS}`,
    body,
  });
  return res;
};
const createManualContact = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.CREATE_MANUAL_CONTACT,
    body,
  });
  return res;
};
const addPasswordSheet = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.ADD_PASSWORD_SHEET,
    body,
  });
  return res;
};
const getPasswordSheet = async (id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  let res = await FETCH.get({
    url:
      userRole === "protrustee" || userRole === "trustee" || userRole === "Financial Advisor Client"
        ? `${ROUTES.GET_PASSWORD_SHEET}?clientId=${id}`
        : ROUTES.GET_PASSWORD_SHEET,
  });
  return res;
};
const updatePasswordSheet = async (body) => {
  let res = await FETCH.put2({
    url: ROUTES.UPDATE_PASSWORD_SHEET,
    body,
  });
  return res;
};
const DeleteSelectedContacts = async (body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.DELETE_SELECTED_CONTACTS}`,
    body: { contactIds: body },
  });
  return res;
};

const sendEmailsToGroup = async (id, body) => {
  let res = await FETCH.post({
    url: `${ROUTES.SEND_GROUP_EMAILS}?groupId=${id}`,
    body,
  });
  return res;
};
const getPeopleWithAccess = async (id) => {
  let res = await FETCH.get({
    url: `${ROUTES.GET_PEOPLE_WITH_ACCESS}`,
  });
  return res;
};
const cancelTrusteeAccess = async (body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.CANCEL_TRUSTEE_ACCESS}`,
    body,
  });
  return res;
};
const addContactsFromClient = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.ADD_CONTACTS_FROM_CLIENT}`,
    body: body,
  });
  return res;
};
const addContactsFromGroups = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.ADD_CONTACTS_FROM_GROUP}`,
    body: body,
  });
  return res;
};
const createCategory = async (body) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.post({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.CREATE_CATEGORY}?clientId=${ID}`
        :  `${ROUTES.CREATE_CATEGORY}`,
    body: body,
  });
  return res;
};
const getCategories = async (divorceBudget) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.CREATE_CATEGORY}?divorceBudget=${divorceBudget}&clientId=${ID}`
        : `${ROUTES.CREATE_CATEGORY}?divorceBudget=${divorceBudget}`,
  });
  return res;
};
const getBudget = async () => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.CREATE_BUDGET}?clientId=${ID}`
        : `${ROUTES.CREATE_BUDGET}`,
  });
  return res;
};
const createBudget = async (body) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.post({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.CREATE_BUDGET}?clientId=${ID}`
        : `${ROUTES.CREATE_BUDGET}`,
    body: body,
  });
  return res;
};
const updateBudget = async (id, body) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let url = ROUTES.UPDATE_BUDGET;

  if (id) {
    url += `?budgetId=${id}`;
    if (userRole === "Financial Advisor Client") {
      url += `&clientId=${ID}`;
    }
  } else if (userRole === "Financial Advisor Client") {
    url += `?clientId=${ID}`;
  }
  let res = await FETCH.put2({
    url: url,
    body,
  });
  return res;
};
const deleteBudget = async (id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.put2({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.DELETE_BUDGET}?budgetId=${id}&clientId=${ID}`
        : `${ROUTES.DELETE_BUDGET}?budgetId=${id}`,
  });
  return res;
};
const getBudgetTransaction = async () => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.GET_TRANSACTION}?clientId=${ID}`
        : ROUTES.GET_TRANSACTION,
  });
  return res;
};
const createBudgetTransaction = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.CREATE_TRANSACTION}`,
    body: body,
  });
  return res;
};
const createClientBudgetTransaction = async (body) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.post({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.CREATE_TRANSACTION_V2}?clientId=${ID}`
        : `${ROUTES.CREATE_TRANSACTION_V2}`,
    body: body,
  });
  return res;
};
const updateBudgetTransaction = async (id, body) => {
   const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.put2({
    url: userRole === "Financial Advisor Client"
        ? `${ROUTES.UPDATE_TRANSACTION}?transactionId=${id}&clientId=${ID}`
        : `${ROUTES.UPDATE_TRANSACTION}?transactionId=${id}`,
    body,
  });
  return res;
};
const deleteBudgetTransaction = async (id) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.put2({
    url:  userRole === "Financial Advisor Client"
        ? `${ROUTES.DELETE_TRANSACTION}?transactionId=${id}&clientId=${ID}`
        : `${ROUTES.DELETE_TRANSACTION}?transactionId=${id}`,
  });
  return res;
};
const getBudgetDataAll = async () => {
  let res = await FETCH.get({
    url: `${ROUTES.DASHBOARD_BUDGET}`,
  });
  return res;
};
const getCalculatedBudget = async () => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.CALCULATED_BUDGET}?clientId=${ID}`
        : `${ROUTES.CALCULATED_BUDGET}`,
  });
  return res;
};
const filterBudgetTransaction = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.FILTER_TRANSACTION}`,
    body: body,
  });
  return res;
};
const filterBudgets = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.FILTER_BUDGET}`,
    body: body,
  });
  return res;
};
const getTransactionHistory = async (id) => {
  let res = await FETCH.get({
    url: `${ROUTES.GET_TRANSACTION_HISTORY}?transactionId=${id}`,
  });
  return res;
};
// const getRecurringTransaction = async (query,hidden=false) => {
//   const userRole =
//     localStorage.getItem("role") != "undefined" &&
//     JSON.parse(localStorage.getItem("role"));
//   const ID = localStorage.getItem("accessId");
//   let res = await FETCH.get({
//     url:
//       `${ROUTES.GET_RECURRING_TRANSACTION}${hidden ? "?hidden=true&" : "?hidden=false&"}`,
//     id: query.trim() !== "" && userRole === "Financial Advisor Client"
//       ? `clientId=${ID}&name=${query}`
//       : query.trim() !== ""
//       ? `name=${query}`
//       : userRole === "Financial Advisor Client"
//       ? `clientId=${ID}`
//       : ""
//   });
//   return res;
// };
const getRecurringTransaction = async (query, hidden = false) => {
  const userRole =
    localStorage.getItem("role") !== "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");

  // Build query parameters
  const params = new URLSearchParams();

  if (hidden) params.append("hidden", "true");
  if (query.trim()) params.append("name", query.trim());
  if (userRole === "Financial Advisor Client") params.append("clientId", ID);

  const url = `${ROUTES.GET_RECURRING_TRANSACTION}?${params.toString()}`;

  const res = await FETCH.get({ url });
  return res;
};
const deleteMultipleRecurringTransaction = async (ids) => {
  let res = await FETCH.put2({
    url: `${ROUTES.DELETE_RECURRING}`,
    body: ids,
  });
  return res;
};
const transactionUpload = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.UPLOAD_TRANSACTION}`,
    body: body,
  });
  return res;
};
const refreshBanksData = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.REFRESH_BANK,
    body,
  });
  return res;
};
const deleteLinkTransactions = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.DELETE_LINK_TRANSACTIONS,
    body,
  });
  return res;
};
const deleteLinkModule = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.DELETE_LINK_MODULES,
    body,
  });
  return res;
};
const fetchAssetLoan = async (body) => {
  let res = await FETCH.post({
    url: ROUTES.FETCH_ASSET_LOAN,
    body,
  });
  return res;
};

const searchBank = async (name) => {
  let res = await FETCH.get({
    url: `${ROUTES.SEARCH_BANK}?name=${name}`,
  });
  return res;
};
const getPlaidBanks = async (page) => {
  let res = await FETCH.get({
    url: `${ROUTES.GET_PLAID_BANKS}?count=50&page=${page}`,
  });
  return res;
};
const getUpdatedRole = async () => {
  let res = await FETCH.get({
    url: `${ROUTES.GET_UPDATED_ROLE}`,
  });
  return res;
};
const updateUserAssetSetting = async (body) => {
  let res = await FETCH.put2({
    url: ROUTES.UPADTE_USER_ASSET_SETTING,
    body,
  });
  return res;
};
const refreshLiability = async () => {
  let res = await FETCH.get({
    url: `${ROUTES.REFRESH_LIABILITY}`,
  });
  return res;
};
const getAccountUpdatedBalance = async () => {
  let res = await FETCH.get({
    url: `${ROUTES.PLAID_UPDATED_BALANCE}`,
  });
  return res;
};
const googleAuthLogin = async () => {
  let res = await FETCH.get({
    url: `${ROUTES.GOOGLE_AUTH_LOGIN}`,
  });
  return res;
};
const getCollectableValues = async () => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.COLLECTABLES_VALUE}?clientId=${ID}`
        : `${ROUTES.COLLECTABLES_VALUE}`,
  });
  return res;
};
const hideRecurringTransaction = async (ids) => {
  let res = await FETCH.post({
    url: `${ROUTES.HIDE_RECURRING}`,
    body: ids,
  });
  return res;
};
const unhideRecurringTransaction = async (ids) => {
  let res = await FETCH.post({
    url: `${ROUTES.UNHIDE_RECURRING}`,
    body: ids,
  });
  return res;
};
const getBudgetChartData = async (body) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.post({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.BUDGET_CHART}?clientId=${ID}`
        : `${ROUTES.BUDGET_CHART}`,
    body: body,
  });
  return res;
};
const getBudgetChartDataMonthly = async (startDate, endDate, body) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.post({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.BUDGET_CHART}?clientId=${ID}`
        : `${ROUTES.BUDGET_CHART}`,
    body: body,
  });
  return res;
};
export default {
  fetchPasswords,
  addPasswords,
  fetchContactList,
  addPersonalInstructions,
  updatePersonalInstructions,
  fetchPersonalInstructions,
  addContactList,
  deletePersonalInstruction,
  deleteContact,
  deletePassword,
  addPrepaidBurial,
  deletePrepaidBurial,
  fetchPrepaidBurial,
  addBills,
  deleteBills,
  fetchBills,
  fetchLitigation,
  deleteLitigation,
  addLitigation,
  fetchAccountAsset,
  deleteAccountAsset,
  addAccountAsset,
  updateAccountAsset,
  addPersonalItemLocation,
  deletePersonalItemLocation,
  fetchPersonalItemLocation,
  addPolicies,
  updatePersonalItemLocation,
  fetchPolicy,
  deletePolicy,
  addDocuments,
  deleteDocument,
  fetchDocuments,
  updatePasswords,
  upsertChecklist,
  fetchChecklist,
  updateContact,
  updatePrepaidBurial,
  updateBills,
  getSpouseDetails,
  getDependentDetails,
  updateLitigation,
  updateDocument,
  updatePolicy,
  getTrustInfo,
  getCorporateInfo,
  getCharityInfo,
  getOtherImpacts,
  addSpouseInfo,
  addDependentInfo,
  addTrustInfo,
  addCorporateInfo,
  addCharityInfo,
  addOtherImpacts,
  updateSpouseInfo,
  updateDependentInfo,
  updateTrustInfo,
  updateCorporateInfo,
  updateCharityInfo,
  updateOtherImpacts,
  addEmail,
  fetchEmail,
  deleteEmail,
  updateEmail,
  addText,
  fetchText,
  deleteText,
  updateText,
  fetchAudioVideo,
  updateAudioVideo,
  deleteSpouseInfo,
  deleteDependentInfo,
  deleteTrustInfo,
  deleteCorporateInfo,
  deleteCharityInfo,
  deleteOtherImpacts,
  fetchAccountAssetLiabilities,
  fetchTemplates,
  uploadPasswordSheet,
  uploadPolicy,
  uploadDocumnet,
  getPasswordTemplates,
  getDocumentTemplates,
  getPolicyTemplates,
  exportPasswordSheet,
  exportDocumentSheet,
  exportPolicySheet,
  exportContactsSheet,
  verifyOtp,
  searchContactList,
  configOtp,
  confirmDeath,
  getDeathStatus,
  revertDeath,
  postTemplate,
  getTemplate,
  fetchEmailTemplates,
  setRevertTime,
  fetchClientList,
  addAdvanceHealth,
  getAdvanceHealth,
  SendEmails,
  getDeathCertificate,
  PostDeathCertificate,
  postTextTemplate,
  getTextTemplate,
  fetchTextTemplates,
  getSecondPasswordStatus,
  postFuneralInfo,
  getFuneralInfo,
  fetchTrusteeList,
  getEmailHistory,
  getEmailCounts,
  acceptInvitation,
  addIPrefer,
  addPlaceofService,
  addPersonalAccessories,
  getIprefer,
  getPlaceofService,
  getPersonalAccessories,
  deletePersonalAccessories,
  deletePlaceofService,
  deleteIPrefer,
  updatePersonalAccessories,
  updatePlaceofService,
  updateIPrefer,
  getSecureLink,
  createSecureLink,
  deleteSecureLink,
  updateAdvanceHealth,
  getProfileData,
  updateProfileData,
  getPermissions,
  getRoles,
  addRoles,
  deleteRole,
  addPermission,
  deletePermission,
  updatePermission,
  updateRole,
  getUsersList,
  updateUserList,
  createPlaidLinkToken,
  setPlaidPublicToken,
  getBankDetails,
  getBankAccountDetails,
  stripePayment,
  subscriptionDetails,
  getSubscriptionList,
  getStripeProductList,
  getStripeProductsList,
  cancelSubscription,
  promoCodeDetails,
  getCustomerCardsList,
  deleteCustomerCard,
  addToPlan,
  syncAllPlaidRecords,
  syncSinglePlaidRecord,
  sendFeedback,
  DeletePlaidAccount,
  GetCollectablesCount,
  getCollectableListing,
  addCustomerCard,
  makeDefaultCard,
  getInvoices,
  downloadInvoice,
  downloadAllInvoices,
  getGoogleIntialize,
  DeleteAllAccount,
  getClientContacts,
  getOutlookContacts,
  getGoogleContacts,
  getAppleContacts,
  createGroup,
  getGroups,
  deleteGroup,
  updateGroup,
  getGroupContacts,
  createGroupContacts,
  deleteCloudContact,
  updateCloudContact,
  getContactGroup,
  addCloudContactGroup,
  exportCloudContacts,
  importContactFile,
  createManualContact,
  addPasswordSheet,
  getPasswordSheet,
  updatePasswordSheet,
  DeleteSelectedContacts,
  sendEmailsToGroup,
  getPeopleWithAccess,
  cancelTrusteeAccess,
  addContactsFromClient,
  addContactsFromGroups,
  createCategory,
  getCategories,
  getBudget,
  createBudget,
  updateBudget,
  deleteBudget,
  getBudgetTransaction,
  createBudgetTransaction,
  updateBudgetTransaction,
  deleteBudgetTransaction,
  getBudgetDataAll,
  getCalculatedBudget,
  filterBudgetTransaction,
  filterBudgets,
  getTransactionHistory,
  getRecurringTransaction,
  deleteMultipleRecurringTransaction,
  transactionUpload,
  refreshBanksData,
  deleteLinkTransactions,
  deleteLinkModule,
  fetchAssetLoan,
  searchBank,
  getPlaidBanks,
  getUpdatedRole,
  updateUserAssetSetting,
  refreshLiability,
  getAccountUpdatedBalance,
  googleAuthLogin,
  getCollectableValues,
  hideRecurringTransaction,
  getBudgetChartData,
  getBudgetChartDataMonthly,
  createClientBudgetTransaction,
  unhideRecurringTransaction,
};
